import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

export function PricingSection({ tcoString = null, cashPriceString = null, className = null }) {
  return (
    <Row className={classnames('pricing-section', className)}>
      <Col>
        <p className="pricing-label size-16 mb-0_25">True Cost to Own</p>
        <p className="pricing-value heading-2 mb-0">{tcoString}*</p>
      </Col>
      <Col>
        <p className="pricing-label size-16 mb-0_25">Total Cash Price</p>
        <p className="pricing-value heading-2 mb-0">{cashPriceString}</p>
      </Col>
    </Row>
  );
}

PricingSection.propTypes = {
  tcoString: PropTypes.string,
  cashPriceString: PropTypes.string,
  className: PropTypes.string,
};
